import { createSelector } from '@ngrx/store';
import { getRmsSpecificationPage } from '.';
import { PaymentTerm } from '@cemex-core/cmx-api';

export const getPaymentTermsState = createSelector(getRmsSpecificationPage, state => state.PaymentTermsOpenPlatform);

export const getAvailablePaymentTerms = createSelector(getPaymentTermsState, state => {
  const paymentTerms: PaymentTerm[] = [];
  for (const key in state.entities) {
    if (Object.prototype.hasOwnProperty.call(state.entities, key)) {
      paymentTerms.push(state.entities[key]);
    }
  }
  return paymentTerms;
});
